import { useEffect, useState } from "react";
import { getAssetUrl, getMainPageApi } from "../../../../api/api";
import { useWidth } from "../../../../hooks/use-width";
import { TClientBadge } from "../../../../types/types";
import PartnerItem from "../../../common/partner-item/partner-item";
import "./partners-list.sass";

const PartnersList = () => {
  const { isDesktopWidth } = useWidth();
  const [hover, setHover] = useState<undefined | number>(undefined);
  const [clients, setClients] = useState<TClientBadge[]>([]);

  useEffect(() => {
    getMainPageApi()
      .then((data) => {
        const nextClients = Array.isArray(data?.data?.clients)
          ? data.data.clients
          : [];
        setClients(nextClients);
      })
      .catch(() => {
        setClients([]);
      });
  }, []);

  const partnersList = clients.filter((client) => client.logo?.url);

  return (
    <div className="patners-list">
      {isDesktopWidth && (
        <div className="patners-list__row">
          {partnersList.slice(0, 5).map((client, index) => (
            <PartnerItem
              img={getAssetUrl(client.logo?.url)}
              index={index + 1}
              setHover={setHover}
              hover={hover}
              key={client.id}
            />
          ))}
        </div>
      )}
      {isDesktopWidth && (
        <div className="patners-list__row">
          {partnersList.slice(5).map((client, index) => (
            <PartnerItem
              img={getAssetUrl(client.logo?.url)}
              index={index + 5}
              setHover={setHover}
              hover={hover}
              key={client.id}
            />
          ))}
        </div>
      )}

      {!isDesktopWidth &&
        partnersList.map((client, index) => (
          <PartnerItem
            img={getAssetUrl(client.logo?.url)}
            index={index}
            setHover={setHover}
            hover={hover}
            key={client.id}
          />
        ))}
    </div>
  );
};

export default PartnersList;
